<template>
  <div id="produk-form">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{ path: '/' }">Home</router-link>
      </li>
      <li>Pembayaran</li>
      <li>
        <router-link :to="{ path: '/produk' }">Produk</router-link>
      </li>
      <li class="active">{{ !$route.query.id ? "Buat" : "Update" }} Produk</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      {{ !$route.query.id ? "Buat" : "Update" }} Produk
    </h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">
              {{ !$route.query.id ? "Buat" : "Update" }} Produk
            </h4>
          </div>
          <div class="panel-body">
            <div
              class="alert alert-danger fade in m-b-15"
              v-if="this.errors.length > 0"
            >
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" :key="key">
                  {{ message }}
                </li>
              </ul>
            </div>

            <!-- begin form -->
            <form>
              <div class="form-horizontal form-bordered">
                <div class="form-group">
                  <label class="col-md-2 control-label">Tipe Produk</label>
                  <div class="col-md-8 col-xs-12">
                    <select
                      class="form-control"
                      :disabled="$route.query.id"
                      v-model="data.type"
                    >
                      <option value="">-- Pilih Tipe Produk --</option>
                      <option :value="type.SUBSCRIPTION">Subscription</option>
                      <option :value="type.TICKET">Tiket</option>
                      <option :value="type.KUOTA">Kuota</option>
                    </select>
                  </div>
                </div>

                <div v-if="data.type">
                  <div class="form-group">
                    <label class="col-md-2 control-label">Nama Produk</label>
                    <div class="col-md-8 col-xs-12">
                      <input
                        type="text"
                        class="form-control"
                        v-model="data.title"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-md-2 control-label">Platform</label>
                    <div class="col-md-8 col-xs-12">
                      <select v-model="data.platform" class="form-control">
                        <option value="ANDROID">Android</option>
                        <option value="WEB">Web</option>
                        <option value="ALL">Semua</option>
                      </select>
                    </div>
                  </div>
                  <div v-if="data.type === type.SUBSCRIPTION">
                    <div class="form-group">
                      <label class="col-md-2 control-label">Kelas</label>
                      <div class="col-md-4 col-xs-12">
                        <select v-model="jenjang" class="form-control">
                          <option value="SD">SD</option>
                          <option value="SMP">SMP</option>
                          <option value="SMA">SMA</option>
                        </select>
                      </div>
                      <div class="col-md-4 col-xs-12">
                        <select v-model="grade" class="form-control">
                          <option
                            v-for="(item, index) in jenjangList"
                            v-bind:key="index"
                            :value="item"
                          >
                            {{ item }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="col-md-2 control-label">Fitur</label>
                      <div
                        class="col-md-5 col-xs-12"
                        style="display: flex; flex-flow: column"
                      >
                        <!-- <input type="checkbox" class="form-control" v-model="data.features"> -->
                        <span
                          v-for="(item, index) in featureList"
                          v-bind:key="index"
                        >
                          <input
                            type="checkbox"
                            class="checkbox m-r-5"
                            v-model="features"
                            :value="item"
                          /><span class="f-s-14 f-w-700 m-r-10">
                            {{
                              item === "INSTANT_TRYOUT"
                                ? "Tryout Instan"
                                : item === "CONSULTATION"
                                ? "Konsultasi"
                                : item === "DUEL"
                                ? "Duel"
                                : item === "ITEM_BANK"
                                ? "Bank Soal"
                                : item === "SCHEDULED_TRYOUT"
                                ? "Tryout Terjadwal"
                                : item === "VIDEO"
                                ? "Video Pembelajaran"
                                : ""
                            }}
                          </span>
                        </span>
                        <span>
                          <input
                            type="checkbox"
                            class="checkbox m-r-5"
                            v-model="featBimbel"
                            value="true"
                          /><span class="f-s-14 f-w-700 m-r-10">Bimbel</span>
                        </span>
                      </div>

                      <div
                        class="col-md-5 col-xs-12"
                        style="
                          display: flex;
                          flex-flow: column;
                          max-height: 200px;
                          overflow: auto;
                        "
                        v-if="featBimbel"
                      >
                        <span><h5>Pilih Daftar Bimbel</h5></span>
                        <span v-if="bimbelList.length === 0"
                          >Tidak ada bimbel yang bisa dipilih <br />Silahkan
                          pilih kelas lain atau buat bimbel baru</span
                        >
                        <span
                          v-for="(item, index) in bimbelList"
                          v-bind:key="index"
                        >
                          <input
                            type="checkbox"
                            class="checkbox m-r-5"
                            v-model="bimbels"
                            :value="item.id"
                          /><span class="f-s-14 f-w-700 m-r-10">{{
                            item.name
                          }}</span>
                        </span>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-2 control-label"
                        >Durasi (Bulan)</label
                      >
                      <div class="col-md-8 col-xs-12">
                        <input
                          type="number"
                          class="form-control"
                          v-model="data.value"
                          min="1"
                          max="9999"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-2 control-label">Bonus Tiket</label>
                      <div class="col-md-8 col-xs-12">
                        {{ data.bonus }}
                        <input
                          type="number"
                          class="form-control"
                          v-model="data.bonus_value"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-2 control-label">Harga</label>
                      <div class="col-md-8 col-xs-12">
                        <div class="input-group">
                          <span class="input-group-addon">Rp</span>
                          <vue-numeric
                            class="form-control"
                            separator=","
                            v-model="data.net_price"
                          />
                          <span class="input-group-addon">.00</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-2 control-label">Harga Coret</label>
                      <div class="col-md-8 col-xs-12">
                        <div class="input-group">
                          <span class="input-group-addon">Rp</span>
                          <vue-numeric
                            class="form-control"
                            separator=","
                            v-model="data.price"
                          />
                          <span class="input-group-addon">.00</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="data.type === type.TICKET || data.type === type.KUOTA">
                    <div class="form-group">
                      <label class="col-md-2 control-label">
					  {{ data.type === type.KUOTA ? 'Jumlah Kuota' : 'Jumlah Tiket'}}
					  <!-- Jumlah Tiket -->
					  </label>
                      <div class="col-md-8 col-xs-12">
                        <input
                          type="number"
                          class="form-control"
                          v-model="data.value"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-2 control-label">Bonus Tiket</label>
                      <div class="col-md-8 col-xs-12">
                        <input
                          type="number"
                          class="form-control"
                          v-model="data.bonus_value"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-md-2 control-label">Harga</label>
                      <div class="col-md-8 col-xs-12">
                        <div class="input-group">
                          <span class="input-group-addon">Rp</span>
                          <vue-numeric
                            class="form-control"
                            separator=","
                            v-model="data.net_price"
                          />
                          <span class="input-group-addon">.00</span>
                        </div>
                      </div>
                    </div>
					<div class="form-group">
                      <label class="col-md-2 control-label">Harga Coret</label>
                      <div class="col-md-8 col-xs-12">
                        <div class="input-group">
                          <span class="input-group-addon">Rp</span>
                          <vue-numeric
                            class="form-control"
                            separator=","
                            v-model="data.price"
                          />
                          <span class="input-group-addon">.00</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-md-2 control-label">Deskripsi</label>
                    <div class="col-md-8 col-xs-12">
                      <ckeditor
                        :editor="editor"
                        v-model="data.description"
                        :config="editorConfig"
                      ></ckeditor>
                      <br />
                      <span v-if="data.description"
                        ><i
                          >({{
                            characterCounter(data.description)
                          }}
                          karakter)</i
                        ></span
                      >
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-md-2 control-label"
                      >Gambar<br />(Max 1MB)</label
                    >
                    <div class="col-md-8 col-xs-12">
                      <div class="row">
                        <div class="col-md-4" v-if="data.picture">
                          <img class="img-fluid" :src="data.picture" />
                        </div>
                        <div class="col-md-8">
                          <input
                            type="file"
                            class="form-control"
                            accept="image/*"
                            @change="handleChangePicture($event)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-md-2 control-label">Status</label>
                    <div class="col-md-8 col-xs-12">
                      <select class="form-control" v-model="data.status">
                        <option value="">-- Pilih Status --</option>
                        <option :value="status.PUBLISH">Publish</option>
                        <option :value="status.UNPUBLISH">Unpublish</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <hr />
            <div class="pull-right" v-if="data.type">
              <button
                v-if="!$route.query.id"
                type="button"
                class="btn btn-success pull-right"
                @click="saveData()"
              >
                Simpan
              </button>
              <button
                v-else
                type="button"
                class="btn btn-success pull-right"
                @click="editData()"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import SalesService from "@/services/sales.js";
import BimbelService from "@/services/bimbel.js";
import Spinner from "@/components/plugins/Spinner";

export default {
  name: "produk-form",
  components: {
    "app-spinner": Spinner,
  },
  data: function () {
    return {
      errors: [],
      isLoading: false,
      status: {
        PUBLISH: "PUBLISHED",
        UNPUBLISH: "UNPUBLISHED",
      },
      type: {
        SUBSCRIPTION: "SUBSCRIPTION",
        TICKET: "TICKET",
        KUOTA: "CONSULTATION_CREDIT",
      },
      queryId: null,
      selectedPicture: null,
      data: {
        type: "",
        title: null,
        picture: null,
        value: 1,
        bonus_value: 0,
        description: null,
        currency: "RUPIAH",
        price: 0,
        net_price: 0,
        status: "",
        platform: "",
        grade: 0,
        features: "",
      },
      jenjangList: [],
      jenjang: "",
      grade: 0,
      //boolean modelnya checkbox bimbel
      featBimbel: false,
      // variable yang menyimpan list bimbel yang di get dri api
      bimbelList: [],
      // daftar bimbel yg dipilih masuk ke variable ini
      bimbels: [],
      // bimbel di pisah karena punya behavior yang berbeda
      featureList: [
        "SCHEDULED_TRYOUT",
        "INSTANT_TRYOUT",
        // 'DUEL',
        // 'CONSULTATION',
        "ITEM_BANK",
        "VIDEO",
      ],
      features: [],
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "bulletedList",
          "numberedList",
          "blockQuote",
          "|",
          "outdent",
          "indent",
        ],
      },
    };
  },
  watch: {
    jenjang: function (to, from) {
      if (to === "SD") this.jenjangList = [4, 5, 6];
      if (to === "SMP") this.jenjangList = [7, 8, 9];
      if (to === "SMA") this.jenjangList = [10, 11, 12];
    },
    featBimbel: function (to, from) {
      if (to) {
        this.getBimbel();
      } else {
        this.bimbelList = [];
        this.bimbels = [];
      }
    },
    grade: function (to, from) {
      // console.log(to)
      this.data.features = [];
      this.featBimbel = false;
    },
  },
  mounted: function () {
    if (this.$route.query.id) {
      this.queryId = this.$route.query.id;
      this.fetchData();
    }
  },
  methods: {
    fetchData: function () {
      var context = this;
      var queryId = this.queryId;
      this.isLoading = true;

      SalesService.getProdukDetail(queryId, function (result) {
        context.isLoading = false;

        if (result.success) {
          context.data.type = result.data.type;
          context.data.title = result.data.title;
          context.data.picture = result.data.picture;
          context.data.value = result.data.value;
          context.data.bonus_value = result.data.bonus_value;
          context.data.description = result.data.description;
          context.data.currency = result.data.currency;
          context.data.price = result.data.price;
          context.data.net_price = result.data.net_price;
          context.data.status = result.data.status;
          context.data.platform = result.data.platform;
          context.data.grade = result.data.grade;
          context.grade = result.data.grade;
          // context.features = result.data.features
          context.data.features = result.data.features;
          if (result.data.features !== null) {
            var res = result.data.features;
            var sp = res.split(",");
            var format = /[;]/;
            sp.forEach((element) => {
              if (format.test(element)) {
                element = element.slice(0, -1);
                var getbbid = element.split(";");
                for (var i = 1; i < getbbid.length; i++) {
                  context.bimbels.push(parseInt(getbbid[i]));
                }
              } else {
                context.features.push(element);
              }
            });

            //force re-render
            if (context.bimbels.length > 0) {
              context.$nextTick(() => {
                context.featBimbel = true;
              });
            }
          }
          if (context.data.grade < 7) context.jenjang = "SD";
          if (context.data.grade > 6 && context.data.grade < 10)
            context.jenjang = "SMP";
          if (context.data.grade > 9) context.jenjang = "SMA";
        } else {
          alert("Terjadi Kesalahan : " + result.message);
        }
      });
    },
    getBimbel: function () {
      var context = this;
      if (this.data.grade === 0) this.data.grade = 12;
      BimbelService.statPublishedBimbel(this.grade, function (result) {
        context.bimbelList = result.data;
      });
    },
    saveData: function () {
      var context = this;
      var data = this.data;
      this.isLoading = true;
      if (this.validateForm()) {
        this.data.grade = this.grade;
        if (this.featBimbel && this.bimbels.length > 0) {
          var bbl = ";";
          this.bimbels.forEach((element) => {
            bbl += element + ";";
          });
          this.features.push("BIMBEL" + bbl);
        }
        if (this.features.length > 0) {
          this.features.forEach((element) => {
            this.data.features += element + ",";
          });
        }
        this.data.features = this.data.features.slice(0, -1);
        if (this.data.features.length === 0)
          this.data.features = JSON.stringify(this.data.features);
        SalesService.addProduk(data, function (result) {
          if (result.success) context.doUploadPicture(result.data.id);
          else {
            alert("Terjadi Kesalahan : " + result.message);
            context.isLoading = false;
          }
        });
      } else {
        this.isLoading = false;
        $(window).scrollTop(0);
      }
    },
    editData: function () {
      var context = this;
      var id = this.queryId;
      var data = this.data;
      this.isLoading = true;

      if (this.validateForm()) {
        this.data.grade = this.grade;
        this.data.features = "";
        if (this.featBimbel && this.bimbels.length > 0) {
          var bbl = ";";
          this.bimbels.forEach((element) => {
            bbl += element + ";";
          });
          this.features.push("BIMBEL" + bbl);
        }
        if (this.features.length > 0) {
          this.features.forEach((element) => {
            this.data.features += element + ",";
          });
        }
        this.data.features = this.data.features.slice(0, -1);
        if (this.data.features.length === 0)
          this.data.features = JSON.stringify(this.data.features);
        SalesService.updateProduk(id, data, function (result) {
          if (result.success) context.doUploadPicture(id);
          else {
            context.isLoading = false;
            alert("Terjadi Kesalahan : " + result.message);
            context.data.features = "";
            context.features = [];
            context.fetchData();
          }
        });
      } else {
        this.isLoading = false;
        $(window).scrollTop(0);
      }
    },
    handleChangePicture: function (event) {
      const file = event.target.files[0];
      this.selectedPicture = file;
      this.data.picture = URL.createObjectURL(file);
    },
    doUploadPicture: function (id) {
      var context = this;
      var picture = this.selectedPicture;
      var formData = new FormData();

      if (picture) {
        formData.append("name", picture.name);
        formData.append("file", picture);

        SalesService.uploadProdukPicture(id, formData, function (result) {
          if (result.success) context.$router.push({ path: "/produk" });
          else {
            alert("Gagal Upload Picture : " + result.message);
            context.isLoading = false;
            context.data.features = "";
            context.features = [];
            context.fetchData();
          }
        });
      } else {
        context.$router.push({ path: "/produk" });
      }
    },
    validateForm() {
      this.errors = [];
      if (!this.data.type) {
        this.errors.push("Tipe produk wajib diisi");
      } else {
        if (!this.data.title) this.errors.push("Judul wajib diisi");
        if (!this.data.value) {
          this.data.type === this.type.TICKET
            ? this.errors.push("Jumlah tiket wajib diisi")
            : this.errors.push("Durasi wajib diisi");
        }
        if (this.data.value < 1) {
          this.data.type === this.type.TICKET
            ? this.errors.push("Jumlah tiket tidak memenuhi batas minimum")
            : this.errors.push("Durasi tidak memenuhi batas minimum");
        }
        if (this.data.value > 9999) {
          this.data.type === this.type.TICKET
            ? this.errors.push("Jumlah tiket melebihi batas maksimum")
            : this.errors.push("Durasi melebihi batas maksimum");
        }
        if (!this.data.picture) this.errors.push("Gambar wajib diisi");
        if (!this.data.description) this.errors.push("Deskripsi wajib diisi");
        if (this.data.description) {
          if (this.characterCounter(this.data.description) > 1000) {
            this.errors.push("Deskripsi tidak boleh lebih dari 1000 karakter");
          }
        }
        if (!this.data.net_price) this.errors.push("Harga wajib diisi");
        if (this.data.net_price < 1)
          this.errors.push("Harga tidak memenuhi batas minimum");
        if (this.data.price < 1 && this.data.type === this.type.SUBSCRIPTION)
          this.errors.push("Harga Coret tidak memenuhi batas minimum");
        if (this.data.price) {
          if (this.data.price <= this.data.net_price)
            this.errors.push(
              "Harga coret tidak kurang dari atau sama dengan harga normal"
            );
        }
        if (!this.data.status) this.errors.push("Status wajib diisi");
        if (this.selectedPicture) {
          if (this.selectedPicture.size > 1000000)
            this.errors.push("Gambar tidak boleh lebih dari 1MB");
        }
        if (
          this.data.type === this.type.SUBSCRIPTION &&
          this.features.length === 0 &&
          this.featBimbel === false
        )
          this.errors.push("Fitur wajib diisi");
        if (
          this.data.type === this.type.SUBSCRIPTION &&
          this.featBimbel === true &&
          this.bimbels.length === 0
        )
          this.errors.push(
            "Daftar Bimbel wajib diisi apabila memilih fitur bimbel"
          );
      }
      return this.errors.length == 0;
    },
    characterCounter: function (text) {
      text = text.replace(/<[^>]*>/g, "");
      text = text.replace(/\&nbsp;/g, " ");
      return text.length;
    },
  },
};
</script>

<style>
.ck-content {
  min-height: 120px;
}
</style>



// WEBPACK FOOTER //
// ProdukForm.vue?293033e4